import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResult200926 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 20/09/2026 (Marine Martial Arts Lumpini) Results</h3>
      <br />
      <br />


      <div><Link to='/conduct-karlr'>1. AAT  6073  MR.KARL RASMIDATTA(Distinction)---Accquired Rank 3DAN</Link></div>
      <br />
        <div><Link to='/conduct-wannarats'>2. AAT  6201  MS.WANNARAT SOMBATPINYO(Distinction)---Accquired Rank 2DAN</Link></div>
        <br />
        <div><Link to='/conduct-kridsadad'>3. AAT  7552  MR.KRIDSADA DEEROADJANADEJ(Distinction)---Accquired Rank 2DAN</Link></div>
        <br />
        <div><Link to='/conduct-ekasitw'>4. AAT  1187  MR.EKASIT WIPULANUSAT(Distinction)---Accquired Rank 1DAN</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>5. ATT  7731  MS.PAWANRAT CHUPINIJSAK(Distinction)---Accquired Rank 1DAN</Link></div>
        <br />
        <div><Link to='/conduct-santis'>6. AAT  7518  MR.SANTI SIRISAK(Distinction)---Accquired Rank 1DAN</Link></div>
        <br />
        <div><Link to='/conduct-maytapornc'>7. AAT  7732  MS.MAYTAPORN CHUPINIJSAK(Distinction)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>8. AAT  8021  MS.VU NGUYEN QUYNH TRAM(Distinction)---Accquired Rank 4KYU***</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>9. ATT  7951  MS.NAPASANUN VONGVIVAT(P)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>10. ATT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL(P)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>11. AAT  8038  MR.PRAPHATPONG  YOODEE(Distinction)---Accquired Rank 3KYU***</Link></div>
        <br />
        <div><Link to='/conduct-naras'>12. AAT  8040  MASTER NARA SINGHSATHITSUK(P)---Accquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-matsakaj'>13. ATT  8002  MR.MATSAKA JANSAWANG(P)---Accquired Rank 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-marks'>14. AAT 8041  MR.MARK SRIAPORN(Distinction)---Accquired Rank 7KYU***</Link></div>
        <br />
        <div><Link to='/conduct-marvins'>15. AAT 8042  MR.MARVIN SRIAPORN(P)---Accquired Rank 7KYU***</Link></div>
        <br />
        <div><Link to='/conduct-mitts'>16. AAT 8043  MR.MITT SRIAPORN(P)---Accquired Rank 7KYU***</Link></div>
        <br />
        <div><Link to='/conduct-jasona'>17. AAT 8053  MR.HUA YIK ANG(P)---Accquired Rank 7KYU***</Link></div>
        <br />
        <div><Link to='/conduct-nithiss'>18. AAT  8055  MR.NITHIS SIWATHEWINTRA(Distinction)---Accquired Rank 7 KYU***</Link></div>
        <br />
        <div><Link to='/conduct-phusins'>19. AAT  8056  MR.PHUSIN	SIWATHEWINTRA(P)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-niksak'>20. AAT  8058  MR.NIKSA	KIATTHANAPIBOON(P)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-phattarakritl'>21. AAT  8059  MR.PHATTARAKRIT LAPANALARPLOY(P)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pawatchakornh'>22. AAT 8052  MR.PAWATCHAKORN HASUNHA(P)---Accquired Rank 9KYU---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-paricharts'>23. AAT  8061  MS.PARICHART SRIAPORN(P)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-phuphumj'>24. AAT  8062  MR.PHUPHUM JIRACHANKIAT(P)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-salineeb'>25. AAT  7974  MS.SALINEE BOWONRATTANAPAT(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-piyabutrl'>26. AAT  8060  MR.PIYABUTR LORGRAILERS(Distinction)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pathikornk'>27. AAT  8068  MR.PATHIKORN KAJONRUNGSILP(Distinction)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-anukulc'>28. AAT  8069  MR.ANUKUL	CHAMROON(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-natchanonk'>29. AAT  8070  MR.NATCHANON KRAIRAVEE(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-punnawatk'>30. AAT  8071  MR.PUNNAWAT KRAIRAVEE(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-techathatw'>31. AAT  8072  MR.TECHATHAT WATTANAPHORN(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-yothsayaw'>32. AAT  8073  MS.YOTHSAYA	WATTANAPORN(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-puttd'>33. AAT  8074  MR.PUTT	DUANGTOON(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-sirapopes'>34. AAT  8075  MR.SIRAPOPE SOONTORNNUCH(P)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-patwareek'>35. AAT  8076  MS.PATWAREE KITIWATCHARACHAROEN (P)---Accquired Rank 10KYU</Link></div>
        <br />








        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResult200926;
